import React, { memo } from 'react';
import ListHeader from '../ListHeader';
import styles from './styles.module.scss';

var OptionListHeader = function OptionListHeader(_ref) {
  var query = _ref.query,
      searchPlaceHolder = _ref.searchPlaceHolder,
      onQueryChange = _ref.onQueryChange,
      actionButton = _ref.actionButton;
  return (
    /*#__PURE__*/
    React.createElement(ListHeader, null,
    /*#__PURE__*/
    React.createElement("input", {
      type: "text",
      className: styles.search,
      value: query,
      onChange: onQueryChange,
      placeholder: searchPlaceHolder
    }), actionButton)
  );
};

export default memo(OptionListHeader);